const UNSPLASH_HOST = 'images.unsplash.com';

export function buildSrcSet(url: string, widths = [400, 800, 1200]): string | undefined {
  if (!url.includes(UNSPLASH_HOST)) return undefined;
  const u = new URL(url);
  return widths.map(w => {
    u.searchParams.set('w', String(w));
    return `${u.toString()} ${w}w`;
  }).join(', ');
}
